import { SubscriptionLike } from 'rxjs';
import { Observer } from './observer';

/**
 * Event subscription
 */
export class EventSubscription<TEvent> implements SubscriptionLike {
    constructor(
        private observer: Observer<TEvent>,
        private observers: Set<Observer<TEvent>>,
        public unsubscribe: () => void
    ) {}

    get closed() {
        return this.observers.has(this.observer);
    }
}
